// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React, { useState } from "react";
// import DocumentLoader from "./components/DocumentLoader";
// import DocumentDisplay from "./components/DocumentDisplay";
// import AnalyzeButton from "./components/AnalyzeButton";
// import DataExplorer from "./components/DataExplorer";
import LoginCard from "./components/LoginCard";
import Config from "./Config";
import Layout from "./components/Layout";


import { pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

const App = ({
  isSignedIn,
  token,
  // getNextDocument,
  // searchDocument,
  // uploadDocument,
  // analyzeDocument,
}) => {
  console.log("---->", token);
  // const [document, setDocument] = useState();
  // const [analyzingResult, setAnalyzingResult] = useState(false);
  // const [analyzingDocument, setAnalyzingDocument] = useState(false);
  // const [analyzingDocumentError, setAnalyzingDocumentError] = useState();
  // const [polygons, setPolygons] = useState([]);

  // const handlePolygonsUpdate = (keys) => {
  //   setPolygons(keys.map((k) => analyzingResult[k].Geometry.Polygon));
  // };

  // const handleNextDocument = async (index) => {
  //   setPolygons([]);
  //   setDocument();
  //   setAnalyzingResult();
  //   var response = await getNextDocument(index);
  //   setDocument(response);
  //   return response;
  // };

  // const handleSearchDocument = async (bucket, key) => {
  //   setPolygons([]);
  //   setDocument();
  //   setAnalyzingResult();
  //   var response = await searchDocument(bucket, key);
  //   setDocument(response);
  // };

  // const handleUploadDocument = async (bucket, key, file) => {
  //   setPolygons([]);
  //   setDocument();
  //   setAnalyzingResult();
  //   await uploadDocument(bucket, key, file);
  // };

  // const handleAnalyze = async () => {
  //   setPolygons([]);
  //   try {
  //     setAnalyzingDocument(true);
  //     var response = await analyzeDocument(document.bucket, document.key);
  //     setAnalyzingResult(response);
  //   } catch (error) {
  //     setAnalyzingDocumentError(error);
  //   }
  //   setAnalyzingDocument(false);
  // };
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm mt-3">
          {isSignedIn ? (
            <Layout token={token} />
          ) : (
            <LoginCard loginUrl={Config.LoginUrl} />
          )}

          {/* <DocumentLoader
            disabled={!isSignedIn}
            onNext={handleNextDocument}
            onSearch={handleSearchDocument}
            onUpload={handleUploadDocument}
          />
          {document ? (
            <div className="card mt-3">
              <div className="card-body">
                <DocumentDisplay
                  src={document?.signed_url}
                  polygons={polygons}
                />
                <AnalyzeButton
                  disabled={!document?.signed_url}
                  loading={analyzingDocument}
                  onAnalyze={handleAnalyze}
                />
              </div>
            </div>
          ) : (
            <></>
          )} */}
        </div>
        {/* <div className="col-sm mt-3">
          <DataExplorer
            template={document?.template}
            analyzingResult={analyzingResult}
            loading={analyzingDocument}
            error={analyzingDocumentError}
            onPolygonsUpdate={handlePolygonsUpdate}
          />
        </div> */}
      </div>
    </div>
  );
};

export default App;
